// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Injectable } from '@angular/core';
import { InputTextErrorMessages } from '@app/shared/input-text/input-text.component';

export const NAME_PATTERN = /^[\w+=,\.@\-_`]{0,128}$/;
export const DESCRIPTION_PATTERN = /^(.|\n){0,250}$/;

export const REQUIRED_ERROR_MESSAGE = 'Field is required.';

export const DESCRIPTION_PATTERN_ERROR_MESSAGE = 'It must be maximum 250 characters.';
export const NAME_PATTERN_ERROR_MESSAGE = 'It must be maximum 128 characters and contain only alphanumeric ' +
'characters and/or the following: +=,.@-_.';

export const INPUT_TEXT_REQUIRED_ERROR: InputTextErrorMessages = {
    key: 'required',
    message: REQUIRED_ERROR_MESSAGE
};

export const NAME_PATTERN_ERROR: InputTextErrorMessages = {
    key: 'pattern',
    message: NAME_PATTERN_ERROR_MESSAGE
};

export const DESCRIPTION_PATTERN_ERROR = {
    key: 'pattern',
    message: DESCRIPTION_PATTERN_ERROR_MESSAGE
};

@Injectable()
export class InputTextValidatorService {
    descriptionValidator = NAME_PATTERN;
    inputTextValidator = DESCRIPTION_PATTERN;
}



// WEBPACK FOOTER //
// ./src/app/core/services/input-text-validator.service.ts